import React from 'react';
export function TransitionSection() {
  return <section className="py-10 px-4 bg-white border-b border-gray-100" data-id="element-314">
      <div className="max-w-3xl mx-auto text-center" data-id="element-315">
        <h2 className="text-3xl md:text-4xl font-bold font-serif text-gray-900 mb-5 leading-tight" data-id="element-316">
          Quiero asegurarme de que no te quede ninguna excusa para no recuperar
          el control hoy mismo.
        </h2>
        <p className="text-xl text-gray-600 leading-relaxed" data-id="element-317">
          Sé que el cerebro busca razones para esperar:{' '}
          <span className="font-semibold text-gray-900" data-id="element-318">
            No tengo tiempo / Mañana empiezo / El caso de mi perro es imposible.
          </span>
        </p>
      </div>
    </section>;
}